module.exports = __webpack_public_path__ + "static/img/banner_03.fadd4fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/lgis/banner_03.png
// module id = 79OY
// module chunks = 23